import { render } from "./App.vue?vue&type=template&id=f78bbd2c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f78bbd2c&lang=css"

import exportComponent from "D:\\JavaProject\\multilingual_corpus\\multilingual_corpus\\multilingual_corpus_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__